exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".export-route .export-options h4 {\n  text-align: center; }\n\n.export-route .export-options .button-container {\n  text-align: center; }\n\n.export-route .invoices-header {\n  text-align: center; }\n\n.export-route .btn-export-invoices, .export-route .btn-download-csv {\n  width: 150px; }\n\n.export-route button svg {\n  margin-left: 5px;\n  margin-right: 5px; }\n", ""]);

// exports
